import { ReactNode } from 'react';

type WhenProps = {
    condition: boolean;
    children: ReactNode;
    fallback?: ReactNode;
};

function When({ condition, children, fallback = null }: WhenProps) {
    return condition ? children : fallback;
}

export default When;
